import { Box, ButtonIcon, styled, TextField, uiTokens } from '@msdk/ui'
import { ContentCopyRounded } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'

import { CodeType, useCodeContext } from './CodeContext'
import { CodeValidation } from './CodeValidation'

const StyledTextField = styled(TextField)`
  display: flex;
  height: ${uiTokens.sizing.uiControl.height.xLarge}px;
  min-height: ${uiTokens.sizing.minInteractiveTarget}px;
  padding: ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.semiMedium}px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: ${uiTokens.radius.large}px;
  border: ${uiTokens.sizing.stroke.s}px solid ${uiTokens.uiStroke.neutral};
  background: ${uiTokens.uiControl.contained.readonly};

  & .MuiInputBase-root,
  && .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  & .MuiInputBase-root:hover {
    background: ${uiTokens.uiControl.contained.readonly};
    border: none;
  }

  && .MuiInputBase-readOnly {
    border: none;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    font-size: ${uiTokens.font.fontSize.heading.h5}px;
    font-style: normal;
    font-weight: ${uiTokens.font.fontWeight.semiBold};
    line-height: ${uiTokens.font.lineHeight.heading.h5}px;
    letter-spacing: ${uiTokens.font.letterSpacing.loose}em;
    color: ${uiTokens.color.basic.black};
  }
`

const StyledCopyButton = styled(ButtonIcon)`
  && {
    color: ${uiTokens.uiControl.contained.enabled};
  }
  & .MuiSvgIcon-root {
    color: ${uiTokens.uiControl.contained.enabled} !important;
  }
`

const StyledCenteredDiv = styled(Box)`
  display: flex;
  height: ${uiTokens.sizing.uiControl.height.small}px;
  padding: ${uiTokens.spacing.padding.semiMedium}px;
  justify-content: center;
  align-items: center;
  gap: ${uiTokens.spacing.gap.negative?.xxSmall}px;
  align-self: stretch;
`

interface GeneratedCodeFieldProps {
  codeType: CodeType
}

export function GeneratedCodeField({ codeType }: GeneratedCodeFieldProps) {
  const { face, nfc } = useCodeContext()
  const codeInfo = codeType === 'face' ? face : nfc

  return (
    <>
      <StyledTextField
        fullWidth
        value={codeInfo.code?.user_code}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              {codeInfo.code?.user_code && (
                <StyledCopyButton
                  onClick={() => {
                    if (codeInfo.code?.user_code) void navigator.clipboard.writeText(codeInfo.code.user_code)
                  }}
                >
                  <ContentCopyRounded />
                </StyledCopyButton>
              )}
            </InputAdornment>
          ),
        }}
      />
      <StyledCenteredDiv>
        <CodeValidation codeType={codeType} />
      </StyledCenteredDiv>
    </>
  )
}
